import axios from 'axios';

// Cliente único para OC y OV: mismos headers (Bearer) y base URL; no hace falta duplicar para órdenes de venta.

const baseUrl = process.env.REACT_APP_API_URL;
const axiosInstance = axios.create({
    baseURL: baseUrl, // Cambia esto a tu URL base
});

// Interceptor para agregar el token a cada solicitud
axiosInstance.interceptors.request.use(config => {
    const token = localStorage.getItem('token'); // Obtener el token de localStorage
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`; // Agregar el token al encabezado
    }
    return config;
}, error => {
    return Promise.reject(error);
});

export default axiosInstance; 